/* eslint-disable no-constant-condition */
/* eslint-disable multiline-ternary */
import React, { useEffect, useId } from 'react';

import { type NextPage } from 'next';
import { type NextFont } from 'next/dist/compiled/@next/font';
import { TypeAnimation } from 'react-type-animation';

import { PageContainer, VotingEnded } from '../../components/index';
import {
  CategoriesCard,
  Loading,
  SearchBar,
  VoteCard
} from '../../components/util';
import { ifCondition } from '@util/functions';
import useInput from '@util/hooks/useInput';
import {
  useGetCategoriesQuery,
  usePostSearchMutation,
} from '@util/services/ApiConnection';
import useDebounce from '@util/hooks/useDebounce';

// eslint-disable-next-line react/prop-types
const Voting: NextPage<{ inter: NextFont }> = ({ inter }) => {
  const { data, isLoading } = useGetCategoriesQuery(undefined);
  const Id = useId();
  const [search, changeSearch, clearSearch] = useInput('');
  const [getSearch, { data: searchData, isLoading: SearchLoading }] = usePostSearchMutation();
  const searchQuery = useDebounce(search);
  useEffect(() => {
    getSearch({ search: searchQuery });
  }, [searchQuery])
  const filteredData = data?.filter(({ name }: { name: string }) =>
    name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <PageContainer>
      <section
        // eslint-disable-next-line react/prop-types
        className={inter.className}
      >
        {false ? (
          <div
          >
            <SearchBar
              className="mt-12 w-full py-16"
              text='Participants Categories'
              {...{ search, changeSearch, clearSearch }}
            />

            {search === ''
              ? ifCondition(
                !isLoading,
                ifCondition(
                  data != null,
                  <div className="grid grid-cols-2 gap-8 p-6 md:grid-cols-3 md:p-8 lg:grid-cols-4 lg:p-12">
                    {filteredData
                      ?.map((data: { name: string, id: number }, i) => (
                        <CategoriesCard key={`${i}-${Id}`} {...data} i={i} />
                      ))}
                  </div>,
                  <section className="flex min-h-[80vh] items-center justify-center">
                    <TypeAnimation
                      className="animate-pulse text-2xl font-bold lg:text-6xl"
                      sequence={[
                        '57 Winners in 2022',
                        'Would you be the Next?',
                        'More Edition Coming Soon'
                      ]}
                      wrapper="h3"
                      cursor={true}
                      repeat={Infinity}
                      style={{ color: '#FA9706' }}
                      speed={1}
                    />
                  </section>
                ),
                <Loading className="mt-8" />
              )
              : ifCondition(
                !SearchLoading,
                ifCondition(
                  (searchData != null) && (searchData?.length ?? -1) > 0,
                  <div className="grid grid-cols-1 gap-8 p-6 md:grid-cols-2 md:p-8 lg:grid-cols-4 lg:p-12">
                    {searchData?.map(({ type, ...data }, i) =>
                      ifCondition(
                        type === 'Nominee',
                        <VoteCard
                          key={`${Id}-${i}`}
                          {...data}
                          category_id={data.category_id}
                          sub_category={data.sub_category_id}
                        />,
                        <CategoriesCard {...data} key={`${Id}-${i}`} />
                      )
                    )}
                  </div>,

                  <p className="mt-6 text-center text-xl font-bold text-darkPurple">
                    No Result for your query
                  </p>
                ),
                <Loading className="mt-8" />
              )}
          </div>
        ) : (
          <VotingEnded />
        )}
      </section>
    </PageContainer>
  );
};

export default Voting;
